__turbopack_context__.v({
  "heroImage": "f7a3fG_heroImage",
  "item": "f7a3fG_item",
  "list": "f7a3fG_list",
  "primary": "f7a3fG_primary",
  "root": "f7a3fG_root",
  "secondary": "f7a3fG_secondary",
});
